import type { FormEvent, RefObject } from "react";
import { Loader2, Send, Sparkles, X } from "lucide-react";

interface BrianPromptBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  loading: boolean;
  placeholder: string;
  inputRef?: RefObject<HTMLInputElement | null>;
  autoFocus?: boolean;
  onClose?: () => void;
}

export default function BrianPromptBar({
  value,
  onChange,
  onSubmit,
  loading,
  placeholder,
  inputRef,
  autoFocus = false,
  onClose,
}: BrianPromptBarProps) {
  return (
    <form onSubmit={onSubmit} className="relative flex items-center">
      <Sparkles
        size={16}
        className="pointer-events-none absolute left-3.5 shrink-0 text-[#1D345F] opacity-70"
        aria-hidden="true"
      />
      <input
        ref={inputRef}
        autoFocus={autoFocus}
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={loading}
        maxLength={2000}
        placeholder={placeholder}
        aria-label={placeholder}
        className="w-full rounded-xl border border-gray-200 bg-gray-50 py-2.5 pl-9 pr-20 text-sm text-gray-800 placeholder-gray-400 transition-colors focus:border-[#1D345F] focus:bg-white focus:outline-none focus:ring-1 focus:ring-[#1D345F] disabled:opacity-60"
      />
      <div className="absolute right-2.5 flex items-center gap-1">
        <button
          type="submit"
          disabled={loading || !value.trim()}
          className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#1D345F] text-white transition-opacity disabled:opacity-40"
          aria-label="Send to Brian"
          title="Send"
        >
          {loading ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />}
        </button>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="flex h-7 w-7 items-center justify-center rounded-lg text-gray-400 hover:text-gray-600"
            aria-label="Close Brian"
            title="Close"
          >
            <X size={13} />
          </button>
        )}
      </div>
    </form>
  );
}
